import type {
  Included,
  Projection,
  ProjectionWSData
} from '@library/types/projection';
import { buildWSUrl } from '@bo-utils/trading';

type ProjectionBase = { projectionId?: string };

export const findProjectionByProjectionId = <T extends ProjectionBase>({
  projectionArray,
  projectionId
}: {
  projectionArray: Array<T>;
  projectionId?: string;
}): T | undefined =>
  projectionArray.find(
    (projection) => projection.projectionId === projectionId
  );

export const onAutoTradeInGameChange = (
  autoTrade: boolean,
  inGame: boolean,
  isAutoTradeChange: boolean = true,
  keepSameValue: boolean = false
) => {
  let changedAutoTrade = autoTrade;
  let changedInGame = inGame;

  if (!keepSameValue) {
    changedAutoTrade = !autoTrade;
    changedInGame = !inGame;
  }

  if (isAutoTradeChange) {
    // Disable inGame if autoTrade is disabled
    changedInGame = !changedAutoTrade && inGame ? false : inGame;
  } else {
    // Enable/Disable autoTrade based on inGame status
    changedAutoTrade = changedInGame;
  }

  return { autoTrade: changedAutoTrade, inGame: changedInGame };
};

export function createProjectionsWebSocket(
  leagueIds: Array<string>
): WebSocket {
  const wsURL = buildWSUrl();
  const ws = new WebSocket(wsURL || window.backoffice.ws);

  ws.onopen = () => {
    leagueIds.forEach((leagueId) => {
      const subscription = JSON.stringify({
        command: 'subscribe',
        identifier: JSON.stringify({
          channel: 'ProjectionsChannel',
          league_id: leagueId
        })
      });
      ws.send(subscription);
    });
  };

  return ws;
}

export function getProjectionsFromWebSocket(event: MessageEvent): {
  projections: Array<Projection<string>>;
  included: Array<Included<string>> | undefined;
} {
  const eventData = JSON.parse(event.data as string) as ProjectionWSData;
  const {
    type,
    message: { data, included } = {
      data: undefined,
      included: undefined
    }
  } = eventData;

  if (type === 'ping' || !data || !included)
    return { projections: [], included };

  return { projections: Array.isArray(data) ? data : [data], included };
}
